var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(parseInt(_vm.lines), function(line) {
        return [
          _c("div", {
            key: "line-" + line,
            staticClass:
              "gobierto-skeleton-spinner gobierto-skeleton-spinner-line",
            style: _vm.stylesLines()
          })
        ]
      }),
      _vm._v(" "),
      _vm._l(parseInt(_vm.squaresRows), function(square) {
        return [
          _c(
            "div",
            {
              key: "square-row-" + square,
              staticClass: "gobierto-skeleton-spinner-container-squares"
            },
            [
              _vm._l(parseInt(_vm.squares), function(square) {
                return [
                  _c("div", {
                    key: "square-" + square,
                    staticClass:
                      "gobierto-skeleton-spinner gobierto-skeleton-spinner-square",
                    style: _vm.styleSquares
                  })
                ]
              })
            ],
            2
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }